// Central vehicle class data - the single source of truth for the site.
// Five-tier premium fleet. Prices are driven by the backend pricing engine;
// this file only powers presentation (Fleet page, home teaser, booking form).
//
// ── REAL FLEET PHOTOGRAPHY ─────────────────────────────────────────────
// The `image` URL on each class below is REPRESENTATIVE editorial imagery
// (unbranded, no number plates). To switch to real Sydney James fleet
// photos, simply replace each `image` URL here — every layout (Fleet page
// showcases, home fleet teaser, booking vehicle cards) reads from this
// file and accepts any landscape (~3:2 / 16:9) image. No layout changes
// are required.
// ───────────────────────────────────────────────────────────────────────

import { Users, Briefcase, Award } from "lucide-react";

export const VEHICLE_CLASS_OPTIONS = [
  "Executive Sedan",
  "First Class Sedan",
  "Luxury SUV",
  "Executive Van",
  "Luxury Van",
];

// No sub-type selection anymore - each tier is a distinct vehicle class.
export const VEHICLE_TYPES_BY_CLASS = {};

export const VEHICLE_CLASSES = [
  {
    id: "executive_sedan",
    name: "Executive Sedan",
    tagline: "Executive comfort, everyday reliability.",
    description:
      "Refined, discreet transport for airport transfers, corporate travel and everyday executive journeys.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/3aeb2b71-c3a3-4775-b2b3-77824c8c9518/images/83c3bc96fd4aa2e514a64523a6cc19ac5adaee1780ce45a552ea94edc4425dd8.jpeg",
    capacity: { passengers: "Up to 3", luggage: "3 checked + 2 carry-on", comfort: "Executive" },
    types: null,
    models: ["Mercedes-Benz E-Class", "BMW 5 Series", "Lexus ES300h"],
  },
  {
    id: "first_class_sedan",
    name: "First Class Sedan",
    tagline: "Our finest sedan.",
    description:
      "The pinnacle of chauffeured luxury, reserved for VIPs, executives and special occasions.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/3aeb2b71-c3a3-4775-b2b3-77824c8c9518/images/ceb8bf6c3e8122c2f235bfb4c4d5365374b25d6191c2176d7121bdc504fc4b59.jpeg",
    capacity: { passengers: "Up to 3", luggage: "3 checked + 2 carry-on", comfort: "First Class" },
    types: null,
    models: ["Mercedes-Benz S-Class", "BMW 7 Series", "Audi A8"],
  },
  {
    id: "luxury_suv",
    name: "Luxury SUV",
    tagline: "Elevated space and presence.",
    description:
      "A commanding, spacious ride with extra luggage capacity - ideal for families and small groups.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/3aeb2b71-c3a3-4775-b2b3-77824c8c9518/images/398104ad9b023c7c2c2edb639bc761578de5341a7dd1d26b318082bad66cda6c.jpeg",
    capacity: { passengers: "Up to 4", luggage: "5 checked + 2 carry-on", comfort: "Luxury" },
    types: null,
    models: ["Mercedes-Benz GLE", "BMW X5", "Audi Q7"],
  },
  {
    id: "executive_van",
    name: "Executive Van",
    tagline: "Space, comfort, and calm.",
    description:
      "Business-class group travel in the Mercedes V-Class - generous room for passengers and luggage.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/3aeb2b71-c3a3-4775-b2b3-77824c8c9518/images/e2bda6184831edb50b8f16670e15f49a391b1f8f7c41a402a5584ddcddfdc706.jpeg",
    capacity: { passengers: "Up to 6", luggage: "6 checked + 3 carry-on", comfort: "Executive+" },
    types: null,
    models: ["Mercedes-Benz V-Class"],
  },
  {
    id: "luxury_van",
    name: "Luxury Van",
    tagline: "Maximum capacity, first-class finish.",
    description:
      "The Mercedes Sprinter for larger parties and heavy luggage, without compromising on comfort.",
    // Placeholder — showing a luxury vehicle interior detail until we
    // capture the real Sydney James Sprinter. Swap the URL only.
    image:
      "https://static.prod-images.emergentagent.com/jobs/3aeb2b71-c3a3-4775-b2b3-77824c8c9518/images/1e835fb9d3897fc142d23b4396d310fec538237d842e3117b675d5b3fad6e7b1.jpeg",
    capacity: { passengers: "Up to 14", luggage: "18 checked + 8 carry-on", comfort: "Premium" },
    types: null,
    models: ["Mercedes-Benz Sprinter"],
  },
];

export const CAPACITY_ICONS = { Users, Briefcase, Award };
